import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import styles from "./logout.module.scss";

import { ROUTES } from "../../routes";
import { useDispatch } from "react-redux";
import { clearAuth } from "../../store/features/authSlice";
import { Spinner } from "../../components/Spinner";

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      dispatch(clearAuth());
      navigate(ROUTES.LOGIN, {
        replace: true,
      });
    }, 1000);
  }, []);

  return (
    <div className={styles.app_logout}>
      <Spinner text={"Logging Out.."} />
    </div>
  );
};

export { Logout };
